import { render, staticRenderFns } from "./EntranceSelectionTheme.vue?vue&type=template&id=22f20278&scoped=true&lang=pug&"
import script from "./EntranceSelectionTheme.vue?vue&type=script&lang=ts&"
export * from "./EntranceSelectionTheme.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceSelectionTheme.vue?vue&type=style&index=0&id=22f20278&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f20278",
  null
  
)

export default component.exports